import { Input } from '@/components/ui/Input';
import { Section } from '@/components/ui/Section';
import { Select } from '@/components/ui/Select';
import type { Row, RowLayout } from '@/lib/schema.types';
import { useEditorActions } from '@/store/editor.store';

export function RowProperties({ slideId, row }: { slideId: string; row: Row }) {
  const actions = useEditorActions();

  const setPad = (key: keyof Row['padding'], value: number) =>
    actions.updateRow(slideId, row.id, { padding: { ...row.padding, [key]: value } });

  return (
    <>
      <Section title="Layout">
        <Select
          value={String(row.layout)}
          onChange={(e) =>
            actions.updateRow(slideId, row.id, { layout: Number(e.target.value) as RowLayout })
          }
        >
          <option value="1">1 column</option>
          <option value="2">2 columns</option>
          <option value="3">3 columns</option>
          <option value="0">Freeform</option>
        </Select>
      </Section>

      <Section title="Size">
        <div>
          <label className="mb-1 block text-xs font-medium text-fg-muted">
            Height ({row.heightPercent}%)
          </label>
          <input
            type="range"
            min={10}
            max={100}
            value={row.heightPercent}
            onChange={(e) =>
              actions.updateRow(slideId, row.id, { heightPercent: Number(e.target.value) })
            }
            className="w-full accent-accent"
          />
        </div>
      </Section>

      <Section title="Padding">
        <div className="grid grid-cols-2 gap-2">
          {(['top', 'right', 'bottom', 'left'] as const).map((k) => (
            <Input
              key={k}
              type="number"
              label={k}
              value={row.padding[k]}
              onChange={(e) => setPad(k, Number(e.target.value) || 0)}
              min={0}
            />
          ))}
        </div>
      </Section>
    </>
  );
}
